// Copyright 2026 - Hewlett Packard Enterprise Company

import { useEffect, useRef } from 'react';
import useFlags from '../../hooks/useFlags';
import {
  redirectToGlcpLogin,
  getOidcSessionKey,
  saveRedirectRoute,
} from '../../utils/authHelpers';
import {
  COM_TAB_MARKER_PREFIX,
  WORKSPACE_ID_KEY,
} from '../../constants/authConst';

function isDuplicateTab(oidcKey) {
  if (!oidcKey || window.name.startsWith(COM_TAB_MARKER_PREFIX)) {
    return false;
  }

  return !!sessionStorage.getItem(oidcKey);
}

export default function DuplicateTabGuard({ children }) {
  const oidcKey = getOidcSessionKey();
  const flags = useFlags();
  const deepLinkFlag = flags.T_20260513_122476_WORKSPACE_DEEP_LINK_BOOL();
  const redirected = useRef(false);

  useEffect(() => {
    if (redirected.current) return;

    if (isDuplicateTab(oidcKey)) {
      redirected.current = true;

      // Clear the duplicated OIDC session
      sessionStorage.removeItem(oidcKey);

      // Preserve the current route so postLoginRedirect can restore it
      saveRedirectRoute(window.location.pathname, window.location.search);

      const workspaceId = localStorage.getItem(WORKSPACE_ID_KEY) || undefined;
      redirectToGlcpLogin({ workspaceId, deepLinkFlag });
    }
  }, [deepLinkFlag, oidcKey]);

  if (redirected.current || isDuplicateTab(oidcKey)) {
    return null;
  }

  return children;
}
